import React, { useState } from 'react'
import { Form, Spinner } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import LocationForm from './LocationForm'

import { updateLocation } from '../services'
import { handleError } from '../../../helpers'

export default function EditLocationModal({ visible, onClose, location, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm({ defaultValues: location })
	const [loading, setLoading] = useState(false)

	const onSubmit = values => {
		setLoading(true)
		if(location.sap_sku === values.sap_sku) delete values.sap_sku
		updateLocation(location.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Actualizar Registro</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<LocationForm 
						register={register}
						errors={errors}
						editable
					/>
					<Button color='primary' type="submit" disabled={loading}>
						{ loading && <Spinner animation="border" size="sm" className='mr-1' /> }
						Actualizar Registro
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}